import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Registry } from '@/registry.service';
import { DialogPopUpComponent } from '@components/dialog-pop-up/dialog-pop-up.component';
import { LoggerService } from '@services/logger.service';
import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { ToastrService } from 'ngx-toastr';
import { SubAgent } from '@/models/sub-agent';
import { SubagentAgencyService } from '@services/data-source-tables/subagent-agency.service';

@Component({
  selector: 'app-button-subagent-delete',
  templateUrl: '../../button.component.html',
  styleUrls: ['../../button.component.scss'],
})
export class ButtonDeleteSubAgentComponent extends ButtonComponent implements OnInit {
  faIcon = faTrashCan;
  private subAgent: SubAgent;
  private rowData: any;

  constructor(
    protected router: Router,
    public dialog: MatDialog,
    protected subAgencyService: SubagentAgencyService,
    protected toastr: ToastrService,
  ) {
    super(router, toastr);

    this.color = 'danger';
    this.additionalClass = 'py-0.5 px-2.5';
    this.showIcon = true;
    this.smallBtn = true;
  }

  ngOnInit() {
    this.subAgent = <SubAgent>this.rowData;
  }

  /**
   * Delete user
   */
  public actionClick(): void {
    let dialogRef = this.dialog.open(DialogPopUpComponent, {
      width: 'auto',
      panelClass: 'custom-modalbox',
    });

    this.setupPopup(dialogRef);

    dialogRef.afterClosed().subscribe((deleteSubAgent) => {
      if (deleteSubAgent) {
        this.subAgencyService.deleteSubAgent(this.subAgent.id).subscribe({
          next: () => {
            this.toastr.success('Subagente cancellato correttamente!');

            Registry.getInstance().get('SubagentAgencyComponent').loadSubagentAgency();
          },
          error: (error) => {
            LoggerService.error('deleteSubAgent failed!');
            LoggerService.error(error);

            this.toastr.error(`Errore durante la cancellazione del Subagente.`);
          },
          complete: () => {
            LoggerService.log('Request done');
          },
        });
      }
    });
  }

  private setupPopup(dialogRef: MatDialogRef<DialogPopUpComponent>) {
    dialogRef.componentInstance.title = 'Confermi di voler cancellare questo subagente?';
    dialogRef.componentInstance.content =
      'Attenzione una volta cancellata il subagente non sarà più possibile recuperarlo.';
    dialogRef.componentInstance.firstCTA = 'Si cancella';
    dialogRef.componentInstance.secondCTA = 'Annulla operazione';
    dialogRef.componentInstance.closeResultFirst = true;
    dialogRef.componentInstance.closeResultSecond = false;
  }
}
